import { render } from "./ModalShip_fingers.vue?vue&type=template&id=50c92af7"
import script from "./ModalShip_fingers.vue?vue&type=script&lang=js"
export * from "./ModalShip_fingers.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__